<template>
  <div class="task" :class="{ 'task-ready': isReady }">
    <div class="task-tile">
      <div class="task-info">
        <div class="task-status-icon">
          <i v-if="!isReady" class="fas fa-hourglass-half task-status-img"></i>
          <i v-else class="fas fa-check task-status-img"></i>
        </div>
        <div class="task-status">
          <p class="task-status-text" :class="{ 'ready': isReady }">{{ task.task_status_name_fr }}</p>
        </div>
      </div>
      <app-lines :lines="task.lines"></app-lines>
    </div>
  </div>
</template>

<script>
import Lines from '../lines/Lines.vue'
import Separator from '../shared/Separator.vue'

export default {
  props: ['task'],
  data () {
    return {
      taskStatusId: 4,
      taskStatusText: 'Prêt'
    }
  },
  computed: {
    isReady () {
      return this.task.task_status_name_fr === this.taskStatusText
    }
  },
  components: {
    appLines: Lines,
    appSeparator: Separator
  }
}
</script>

<style scoped lang="scss">
  .task {
    width: 90%;
    height: auto;
    max-width: 400px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    background-color: #FF792C;
    margin: 15px auto;
    box-shadow: 0px 0px 5px 3px lightgray;

    &.task-ready {
      background-color:#70BE00;
    }
  }

  .task-tile {
    width: calc(100% - 6px);
    height: 100%;
    background-color: #fff;
    margin: 0px 0px 0px 6px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
  }

  .task-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-between;
    -webkit-align-items: center;
    width: 100%;
    height: 80px;
    padding: 10px 15px;
  }

  .task-status-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    -webkit-display: flex;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    -webkit-flex-wrap: wrap;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    height: 60px;
    width: 60px;
    padding: 5px;
    border: 1px solid white;
    box-shadow: 0px 0px 10px 1px lightgrey;
    text-align: center;
    font-size: 30px;
    color: #FF792C;
  }

  .task-status-img {
    &.fa-hourglass-half {
      animation: rotate 10s forwards infinite;
      -webkit-animation: rotate 10s forwards infinite;
    }
    
    &.fa-check {
      color: #70BE00;
    }
  }

  .task-status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: column;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    font-size: 1.5em;
    width: calc(100% - 65px);
    height: 60px;

    .task-status-text {
      font-weight: 700;
      color: #FF792C;
      text-align: center;
      margin: 0;

      &.ready {
        color: #70BE00;
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0);
      -webkit-transform: rotate(0);
    }
    10% {
      transform: rotate(180DEG);
      -webkit-transform: rotate(180DEG);
    }
    45% {
      transform: rotate(180DEG);
      -webkit-transform: rotate(180DEG);
    }
    55% {
      transform: rotate(360DEG);
      -webkit-transform: rotate(360DEG);
    }
    100% {
      transform: rotate(360DEG);
      -webkit-transform: rotate(360DEG);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/task/Task.vue